// Low stock -> order, never sent automatically. The database puts each item that drops to / below its minimum on the
// wishlist (source 'stock', sql/test-fixes-1.sql) and tells the head of department + Captain. Ordering the open low-stock
// lines is ONE call for the Wishlist page button and the AI card alike: wishlist_create_orders() makes one DRAFT order per
// preferred supplier (lines without one go to a single "no supplier" draft). Nothing is sent; the normal approval rules apply.

export const lowStockLines = items => (items || []).filter(i => i.status === 'open' && i.source === 'stock')

// [{ supplier_id, supplier, items }] - named suppliers first (A-Z), then "No supplier"
export function supplierGroups(lines, sups) {
  const name = Object.fromEntries((sups || []).map(s => [s.id, s.name]))
  const by = new Map()
  for (const i of lines || []) {
    const k = i.supplier_id && name[i.supplier_id] ? i.supplier_id : null
    if (!by.has(k)) by.set(k, { supplier_id: k, supplier: k ? name[k] : 'No supplier', items: [] })
    by.get(k).items.push(i)
  }
  return [...by.values()].sort((a, b) => (a.supplier_id ? 0 : 1) - (b.supplier_id ? 0 : 1) || a.supplier.localeCompare(b.supplier))
}

// what wishlist_create_orders() takes: each line with its preferred supplier (or none)
export const orderPayload = (lines, sups) => supplierGroups(lines, sups).flatMap(g => g.items.map(i => ({ id: i.id, supplier_id: g.supplier_id })))

// card / confirm text: one line per draft order
export const groupLines = (lines, sups) => supplierGroups(lines, sups).map(g => g.supplier + ': ' + g.items.length + ' item' + (g.items.length > 1 ? 's' : '') + ' (' + g.items.slice(0, 4).map(i => i.item + ' x' + i.qty).join(', ') + (g.items.length > 4 ? ' ...' : '') + ')')

export const stockBriefingLine = n => n > 0 ? n + ' item' + (n > 1 ? 's' : '') + ' below minimum on the wishlist - want me to draft the order?' : null
